import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCustomPostPreview, getFBAdPreview } from 'redux/modules/adBuilder';
import { IframePreview, Spinner } from 'components';
var AdPlanIframePreviewWrap = (_dec = connect(function (state, props) {
  var orgId = state.organization.current.id;
  return {
    organization: state.organization.current,
    facebookAdAccount: state.ads.adAccount && state.ads.adAccount[orgId] ? state.ads.adAccount[orgId] : null,
    loadingFBAdPreview: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)].loadingFBAdPreview : false,
    orgAdBuilder: state.adBuilder["".concat(orgId)] ? state.adBuilder["".concat(orgId)] : {},
    theme: state.theme
  };
}, {
  getCustomPostPreview: getCustomPostPreview,
  getFBAdPreview: getFBAdPreview
}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(AdPlanIframePreviewWrap, _Component);

  var _super = _createSuper(AdPlanIframePreviewWrap);

  function AdPlanIframePreviewWrap(props) {
    var _this;

    _classCallCheck(this, AdPlanIframePreviewWrap);

    _this = _super.call(this, props);
    _this.state = {
      fbAdPreviewRendering: true
    };
    return _this;
  }

  _createClass(AdPlanIframePreviewWrap, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.adId) {
        if (this.props.type === 'CUSTOM_POSTS') {
          this.props.getCustomPostPreview(this.props.organization.id, this.props.adId, this.props.facebookAdAccount.facebookPageId);
        } else {
          this.props.getFBAdPreview(this.props.organization.id, this.props.facebookAdAccount.socialAccountId, 'DESKTOP_FEED_STANDARD', {
            adId: this.props.adId
          });
        }
      }
    }
    /** *********************************************************
     RENDER
     ***********************************************************/

  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        style: {
          height: 550,
          width: 520,
          margin: '0 auto'
        }
      }, this.state.fbAdPreviewRendering && /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 200
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })), /*#__PURE__*/React.createElement(IframePreview, _extends({
        style: {
          paddingLeft: 16,
          height: '100%'
        },
        iframeWidth: "100%",
        selectedPreviewTab: "DESKTOP_FEED_STANDARD",
        onLoad: function onLoad() {
          _this2.setState({
            fbAdPreviewRendering: false
          });
        },
        organization: this.props.organization
      }, this.props.orgAdBuilder)));
    }
  }]);

  return AdPlanIframePreviewWrap;
}(Component), _defineProperty(_class2, "defaultProps", {
  adId: null,
  type: ''
}), _temp)) || _class);
export { AdPlanIframePreviewWrap as default };